import React from 'react';
import { T } from '../../motion';
import {
  ProgressSegments,
  ProgressSegment,
  ProgressSegmentFill,
} from './onboarding.styled';

interface OnboardingProgressProps {
  current: number; // 1-based index of the active step
  total: number;
}

// Discrete segment bars (mockup .prog): one per step, lit up to the current one.
// Each fill SCALES in from the left when its step is reached (and back out when
// the user steps back), so the bar is seen to move rather than to re-tint. The
// group is a progressbar for assistive tech: "Step 2 of 4".
export const OnboardingProgress: React.FC<OnboardingProgressProps> = ({
  current,
  total,
}) => {
  return (
    <ProgressSegments
      role="progressbar"
      aria-label="Setup progress"
      aria-valuemin={1}
      aria-valuemax={total}
      aria-valuenow={current}
      aria-valuetext={`Step ${current} of ${total}`}
    >
      {Array.from({ length: total }, (_, i) => (
        <ProgressSegment key={i}>
          <ProgressSegmentFill
            $current={i === current - 1}
            initial={false}
            animate={{ scaleX: i < current ? 1 : 0 }}
            transition={T.base}
          />
        </ProgressSegment>
      ))}
    </ProgressSegments>
  );
};
